import { styled } from "styled-components";

export const ProductListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;
